import { AppThunk } from '../../../store/rootReducer';
import * as annotationClient from '../clients/annotation.client';
import * as annotationTaskActions from '../actions/annotation-task.actions';
import { annotationTaskSelector } from '../selectors/annotation-task.selectors';

export const loadNextAnnotation =
  (): AppThunk<Promise<string | undefined>> => async (dispatch, getState) => {
    const nextAnnotation = await annotationClient.getNextAnnotation();
    const previousAnnotationTask = annotationTaskSelector(getState());

    if (
      previousAnnotationTask != null &&
      nextAnnotation != null &&
      previousAnnotationTask.id !== nextAnnotation.annotationTask.id
    ) {
      dispatch(
        annotationTaskActions.setPreviousAnnotationTask({
          previousAnnotationTask: {
            id: previousAnnotationTask.id,
            name: previousAnnotationTask.name,
          },
        }),
      );
    }

    dispatch(
      annotationTaskActions.setAnnotation({ annotation: nextAnnotation }),
    );
    return nextAnnotation?.ecgId;
  };
